import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import { useAppContext } from '@at/sauron-platform-core';
import { useLocation } from 'react-router';
import { usePageState } from '@at/sauron-platform-core';
import { useUserState, withSignInEntityProvider } from '@at/connected-signin';
import { HeaderPresentational } from '../presentational/connected-header';
import { buildAfterSignInUrl, useHeaderTrackingCallbacks } from '../logic/connected-header.logic';
const BaseConnectedHeader = (props) => {
    const { afterSignInCallback, disableConnectedSignIn } = props;
    const [userState] = useUserState();
    const trackingHeadingCallbacks = useHeaderTrackingCallbacks();
    const { state } = usePageState();
    const { config: { env }, } = useAppContext();
    const [showSignInModal, setShowSignInModal] = useState(false);
    const { pathname, search } = useLocation();
    const afterSignInUrl = buildAfterSignInUrl(pathname, search);
    const signInProps = !disableConnectedSignIn
        ? {
            useNewSignIn: true,
            userSignedIn: userState.userSignedIn,
            afterSignInUrl,
            showSignInModal,
            setShowSignInModal,
            afterSignInCallback,
        }
        : {
            showSignInModal: false,
            afterSignInUrl: '',
        };
    return (_jsx(HeaderPresentational, Object.assign({ trackingCallbacks: trackingHeadingCallbacks, channel: (state === null || state === void 0 ? void 0 : state.channel) || props.channel, environment: env }, signInProps, props)));
};
export const ConnectedHeader = withSignInEntityProvider(BaseConnectedHeader, 'GLOBAL_NAV');
